export default __webpack_public_path__ + "static/media/reaction-05.66774b07.svg";